import React from 'react';
import { Route, Switch } from 'react-router-dom';

import IndexController from './controllers/Index.controller'
import QrController from './controllers/Qr.controller'

const ApplicationRoutes = (props) => (
    <Switch>
        <Route exact path="/" render={(p) => <IndexController {...props} {...p}/>} />
        <Route exact path="/qr" render={(p) => <QrController {...props} {...p}/>} />
    </Switch>
);

export default ApplicationRoutes;



// WEBPACK FOOTER //
// ./src/router_auth.js